import {
  AccountTree,
  Category,
  Code,
  FactCheck,
  Gavel,
  GppGood,
  HowToReg,
  Hub,
  Insights,
  Lock,
  ManageAccounts,
  Person,
  QueryStats,
  Rule,
  Security,
  SupervisorAccount,
  SupportAgent,
  Visibility,
  VpnKey,
  Work,
} from '@mui/icons-material';

import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material';
import { ValueOf } from '../utilities/types';

const permissionIconNames = {
  ACCOUNT_TREE_FILLED: 'AccountTreeFilled',
  CATEGORY_FILLED: 'CategoryFilled',
  CODE_FILLED: 'CodeFilled',
  FACT_CHECK_FILLED: 'FactCheckFilled',
  GPP_GOOD_FILLED: 'GppGoodFilled',
  GAVEL_FILLED: 'GavelFilled',
  HOW_TO_REG_FILLED: 'HowToRegFilled',
  HUB_FILLED: 'HubFilled',
  INSIGHTS_FILLED: 'InsightsFilled',
  LOCK_FILLED: 'LockFilled',
  MANAGE_ACCOUNTS_FILLED: 'ManageAccountsFilled',
  PERSON_FILLED: 'PersonFilled',
  QUERY_STATS_FILLED: 'QueryStatsFilled',
  RULE_FILLED: 'RuleFilled',
  SECURITY_FILLED: 'SecurityFilled',
  SUPERVISOR_ACCOUNTS_FILLED: 'SupervisorAccountsFilled',
  SUPPORT_AGENT_FILLED: 'SupportAgentFilled',
  VISIBILITY_FILLED: 'VisibilityFilled',
  VPN_KEY_FILLED: 'VpnKeyFilled',
  WORK_FILLED: 'WorkFilled',
} as const;

export type PermissionIconName = ValueOf<typeof permissionIconNames>;

export const iconNameIconMap: Record<PermissionIconName, OverridableComponent<SvgIconTypeMap>> = {
  [permissionIconNames.ACCOUNT_TREE_FILLED]: AccountTree,
  [permissionIconNames.CATEGORY_FILLED]: Category,
  [permissionIconNames.CODE_FILLED]: Code,
  [permissionIconNames.FACT_CHECK_FILLED]: FactCheck,
  [permissionIconNames.GPP_GOOD_FILLED]: GppGood,
  [permissionIconNames.GAVEL_FILLED]: Gavel,
  [permissionIconNames.HOW_TO_REG_FILLED]: HowToReg,
  [permissionIconNames.HUB_FILLED]: Hub,
  [permissionIconNames.INSIGHTS_FILLED]: Insights,
  [permissionIconNames.LOCK_FILLED]: Lock,
  [permissionIconNames.MANAGE_ACCOUNTS_FILLED]: ManageAccounts,
  [permissionIconNames.PERSON_FILLED]: Person,
  [permissionIconNames.QUERY_STATS_FILLED]: QueryStats,
  [permissionIconNames.RULE_FILLED]: Rule,
  [permissionIconNames.SECURITY_FILLED]: Security,
  [permissionIconNames.SUPERVISOR_ACCOUNTS_FILLED]: SupervisorAccount,
  [permissionIconNames.SUPPORT_AGENT_FILLED]: SupportAgent,
  [permissionIconNames.VISIBILITY_FILLED]: Visibility,
  [permissionIconNames.VPN_KEY_FILLED]: VpnKey,
  [permissionIconNames.WORK_FILLED]: Work,
};

export default permissionIconNames;
